
export const orderLogActions = self => ({

  set(key, value) {
    self[key] = value
  }
})